import Vue from "vue";
import Vuex from 'vuex'
import router from "./router";
import "./axios/"
import Meta from 'vue-meta'
import TextHighlight from 'vue-text-highlight';
import App from "./App";
import VueAnalytics from 'vue-analytics';

Vue.use(Meta);
Vue.use(Vuex);

Vue.component('text-highlight', TextHighlight);

Vue.use(VueAnalytics, {
  id: 'UA-179308580-1',
  router
});

const store = new Vuex.Store({
  state: {
    // concept_mastered: {},
    // concept_goal:{},
    concept_mastered: [],
    concept_goal:[]
  },
  mutations: {
    updateMastered (state, new_concept_mastered) {
      state.concept_mastered = new_concept_mastered
    },
    updateGoal (state, new_concept_goal) {
      state.concept_goal = new_concept_goal
    }
  }
})

new Vue({
  el:"#app",
  store:store,
  router,
  template:"<App/>",
  components:{App}
});



// WEBPACK FOOTER //
// ./src/main.js